<template>
  <div class="challengesList" v-if="!loading">
    <div class="challengesList_header">
      <div class="header_title">
        <h2>チャレンジリスト</h2>
        <p class="header_value">{{ challengesList.length }}件</p>
      </div>
    </div>
    <div class="challengesList_list_wrapper">
      <ul class="challengesList_list">
        <li
          class="item"
          v-bind:class="{
            update: challengeData.update == index,
            current: picked == 0,
          }"
          v-for="(item, index) in challengesList"
          :key="index"
        >
          <div class="item_div">
            <button
              @click="
                $router.push({ name: 'Challenge', params: { cid: item.id } })
              "
              class="item_title"
            >
              {{ item.data.data.name }}
            </button>
            <div class="item_graph">
              <div class="graph_img" style="transform: rotate(-90deg)">
                <svg
                  height="100%"
                  viewBox="0 0 20 20"
                  width="100%"
                  style="overflow: visible"
                >
                  <circle
                    cx="50%"
                    cy="50%"
                    fill="none"
                    stroke-width="1"
                    r="9"
                    stroke="#E6EAE6"
                  />
                  <circle
                    cx="50%"
                    cy="50%"
                    fill="none"
                    stroke-width="1"
                    r="9"
                    stroke="#F18D5F"
                    stroke-linecap="round"
                    :style="`stroke-dashoffset:${graph_num(
                      item
                    )};stroke-dasharray: 56.5487`"
                  />
                </svg>
              </div>
              <label>
                <input type="radio" name="current" @change="pickup(item)" />
              </label>
              <p class="graph_percentage">
                <span>{{ graph_percent(item) }}</span
                >%
              </p>
              <div class="graph_detail">
                <p>今のペース</p>
                <p class="fraction">
                  <span>{{ graph_mai(item) }}</span
                  >枚/<span>{{ graph_day(item) }}</span
                  >日
                </p>
              </div>
              <button
                v-if="user"
                class="graph_btn_add"
                v-bind:class="{ active: challengeData.update === index }"
                @click="
                  challengeData.update === index
                    ? (challengeData.update = null)
                    : (challengeData.update = index)
                "
              >
                <i class="fas fa-plus"></i>
              </button>
              <button
                v-if="!user"
                class="graph_btn_cheer"
                @click="
                  maiSend(
                    uid,
                    uname,
                    item.data.host,
                    item.profile.name,
                    item.id
                  )
                "
                :disabled="sendMai"
              >
                <p>応援</p>
                <i class="fas fa-rocket"></i>
              </button>
            </div>
            <p class="item_latest">
              {{ displayTime(new Date(item.data.update.seconds * 1000)) }}
            </p>
          </div>
          <div
            class="challengesList_update pc"
            v-if="challengeData.update == index"
          >
            <div class="update_btn_wrapper">
              <label class="update_btn_add"
                >画像を追加<input
                  type="file"
                  accept="image/*"
                  @change="imagesUpload($event)"
                  multiple
              /></label>
              <button class="update_btn_delete" @click="imagesDelete()">
                削除
              </button>
            </div>
            <div class="update_content_wrapper">
              <ul class="update_content_images">
                <li>
                  <img
                    v-if="challengeData.images[0]"
                    :src="challengeData.images[0]"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    v-if="challengeData.images[1]"
                    :src="challengeData.images[1]"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    v-if="challengeData.images[2]"
                    :src="challengeData.images[2]"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    v-if="challengeData.images[3]"
                    :src="challengeData.images[3]"
                    alt=""
                  />
                </li>
              </ul>
              <div class="update_content_caption">
                <label>
                  <p>
                    <span>キャプションを追加</span
                    ><span id="caption_length"
                      >{{ challengeData.caption.length }}/140</span
                    >
                  </p>
                  <textarea
                    placeholder="空白可"
                    maxlength="140"
                    v-model="challengeData.caption"
                  ></textarea>
                </label>
              </div>
              <button
                class="update_btn_update"
                @click="addPost(item.data.host, item.id)"
              >
                投稿する
              </button>
            </div>
          </div>
        </li>
        <button class="item_add" @click="$router.push({ name: 'New' })">
          <i class="fas fa-plus"></i>
        </button>
      </ul>
    </div>
    <div class="challengesList_current update sp" v-if="picked">
      <div class="item">
        <button
          @click="$router.push({ name: Challenge, params: { cid: picked.id } })"
          class="item_title"
        >
          {{ picked.data.data.name }}
        </button>
        <div class="item_graph">
          <div class="graph_img" style="transform: rotate(-90deg)">
            <svg
              height="100%"
              viewBox="0 0 20 20"
              width="100%"
              style="overflow: visible"
            >
              <circle
                cx="50%"
                cy="50%"
                fill="none"
                stroke-width="1"
                r="9"
                stroke="#E6EAE6"
              />
              <circle
                cx="50%"
                cy="50%"
                fill="none"
                stroke-width="1"
                r="9"
                stroke="#F18D5F"
                stroke-linecap="round"
                :style="`stroke-dashoffset:${graph_num(
                  picked
                )};stroke-dasharray: 56.5487`"
              />
            </svg>
          </div>
          <p class="graph_percentage">
            <span>{{ graph_percent(picked) }}</span
            >%
          </p>
          <div class="graph_detail">
            <p>今のペース</p>
            <p class="fraction">
              <span>{{ graph_mai(picked) }}</span
              >枚/<span>{{ graph_day(picked) }}</span
              >日
            </p>
          </div>
          <button
            v-if="user"
            class="graph_btn_add"
            v-bind:class="{ active: challengeData.update === 1 }"
            @click="
              challengeData.update === 1
                ? (challengeData.update = null)
                : (challengeData.update = 1)
            "
          >
            <i class="fas fa-plus"></i>
          </button>
          <button
            v-if="!user"
            class="graph_btn_cheer"
            @click="
              maiSend(
                uid,
                uname,
                picked.data.host,
                picked.profile.name,
                picked.id
              )
            "
            :disabled="sendMai"
          >
            <p>応援</p>
            <i class="fas fa-rocket"></i>
          </button>
        </div>
        <p class="item_latest">
          {{ displayTime(new Date(picked.data.update.seconds * 1000)) }}
        </p>
      </div>
      <div class="challengesList_update sp" v-if="challengeData.update == 1">
        <div class="update_btn_wrapper">
          <label class="update_btn_add"
            >画像を追加<input
              type="file"
              accept="image/*"
              @change="imagesUpload($event)"
              multiple
          /></label>
          <button class="update_btn_delete" @click="imagesDelete()">
            削除
          </button>
        </div>
        <div class="update_content_wrapper">
          <ul class="update_content_images">
            <li>
              <img
                v-if="challengeData.images[0]"
                :src="challengeData.images[0]"
                alt=""
              />
            </li>
            <li>
              <img
                v-if="challengeData.images[1]"
                :src="challengeData.images[1]"
                alt=""
              />
            </li>
            <li>
              <img
                v-if="challengeData.images[2]"
                :src="challengeData.images[2]"
                alt=""
              />
            </li>
            <li>
              <img
                v-if="challengeData.images[3]"
                :src="challengeData.images[3]"
                alt=""
              />
            </li>
          </ul>
          <div class="update_content_caption">
            <p>
              <span>キャプションを追加</span
              ><span id="caption_length"
                >{{ challengeData.caption.length }}/140</span
              >
            </p>
            <textarea
              placeholder="空白可"
              maxlength="140"
              v-model="challengeData.caption"
            ></textarea>
          </div>
          <button
            class="update_btn_update"
            @click="addPost(picked.data.host, item.id)"
          >
            投稿する
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseUtil from "@/firebase";

export default {
  props: ["challengesList", "picked", "uid", "uname"],
  data() {
    return {
      user: true,
      challengeData: {
        update: null,
        images: [],
        caption: "",
      },
      caption_length: "",
      loading: false,
      postMsg: false,
      sendMai: false,
    };
  },
  computed: {
    pickupWatch() {
      return this.picked;
    },
  },
  watch: {
    pickupWatch() {
      this.loading = false;
    },
  },
  methods: {
    pickup(data) {
      this.$emit("pickup", data);
    },
    graph_num(data) {
      let max = 56 - (56 / data.data.data.goal) * data.data.post;
      return max;
    },
    graph_percent(data) {
      return data.data.post == 0
        ? 0
        : (data.data.post / data.data.data.goal) * 100;
    },
    graph_mai(data) {
      // 今のペース
      if (data.data.post == 0) {
        return 0;
      } else {
        let diff =
          new Date().getTime() -
          new Date(data.data.created.seconds * 1000).getTime();
        let between = Math.floor(diff / 86400000);
        if (between == 0) {
          return data.data.post;
        } else {
          let per = (data.data.post / between).toFixed(1);
          if (per < 1) {
            let count;
            while (per >= 1) {
              per += per;
              count++;
            }
            between = between * count;
            return per;
          } else {
            return per;
          }
        }
      }
    },
    graph_day(data) {
      // 今のペース
      let diff =
        new Date().getTime() -
        new Date(data.data.created.seconds * 1000).getTime();
      let between = Math.floor(diff / 86400000);
      if (between == 0) {
        return 0;
      } else {
        if (data.data.post == 0) {
          return between;
        } else {
          let per = (data.data.post / between).toFixed(1);
          if (per < 1) {
            let count;
            while (per >= 1) {
              per += per;
              count++;
            }
            between = between * count;
            return between;
          } else {
            return between;
          }
        }
      }
    },
    displayTime(unixTime) {
      var date = new Date(unixTime);
      var diff = new Date().getTime() - date.getTime();
      var d = new Date(diff);

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + "年前";
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + "ヶ月前";
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + "日前";
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + "時間前";
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + "分前";
      } else {
        return d.getUTCSeconds() + "秒前";
      }
    },
    imagesUpload(event) {
      const files = [...(event.target.files || event.dataTransfer.files)];
      files.some((item, index) => {
        if (index > 3) {
          return true;
        }
        if (checkFile(item)) {
          getBase64(item).then((picture) => {
            this.challengeData.images.push(picture);
          });
        }
      });

      function checkFile(file) {
        let result = true;
        const SIZE_LIMIT = 5000000; // 5MB
        // ローカルマシンからの読み込みをキャンセルしたら処理中断
        if (!file) {
          result = false;
        }
        // jpeg か png 関連ファイル以外は受付けない
        if (
          file.type !== "image/jpeg" &&
          file.type !== "image/png" &&
          file.type !== "image/webp"
        ) {
          result = false;
        }
        // 上限サイズより大きければ受付けない
        if (file.size > SIZE_LIMIT) {
          result = false;
        }
        return result;
      }

      function getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      }
    },
    imagesDelete() {
      this.challengeData.images.pop();
    },
    addPost(uid, cid) {
      if (this.challengeData.images.length) {
        firebaseUtil.setPost(uid, cid, this.challengeData).then(() => {
          this.challengeData.images = [];
          this.challengeData.caption = "";
          this.postMsg = true;
          this.challengeData.update = null;
          // firebaseUtil.getChallengesList(uid);
          setTimeout(() => {
            this.postMsg = false;
          }, 2000);
        });
      }
    },
    maiSend(uid, name, to_uid, to_name, cid) {
      // maiを送れるのは1秒に一回まで
      let count = 1;
      firebaseUtil
        .setChallengeMai(uid, name, to_uid, to_name, cid, count)
        .then(() => {
          this.sendMai = true;
          setTimeout(() => {
            this.sendMai = false;
          }, 1000);
        });
    },
  },
};
</script>

<style lang="scss">
.challengesList {
  margin-top: 60px;
  &_header {
    @include Section_header();
    padding: 0 4.6vw;
    margin-bottom: 60px;
  }
  &_list {
    @include Section_padding();
    margin-top: 0;
    display: flex;
    align-items: center;
    overflow-x: auto;
    &_wrapper {
      background-color: $bg_base;
    }
    .item {
      padding: 0 60px;
      border-right: 1px solid #ddd;
      &_div {
        width: 240px;
        text-align: center;
      }
      &_title {
        margin: 0 auto;
        @include fz(18);
        @include text_overflow(2);
        &:hover {
          text-decoration: underline;
        }
      }
      &_graph {
        @include challenge_graph(240px, 30, 18);
        position: relative;
        label {
          top: 0;
          left: 0;
          position: absolute;
          height: 100%;
          width: 100%;
          input {
            /* 透明度0 */
            filter: alpha(opacity=0);
            -moz-opacity: 0;
            opacity: 0;
            /* ブラウザのデフォルトのスタイルを削除 */
            -webkit-appearance: none;
            appearance: none;
            /* レイアウトから無視 */
            position: absolute;
          }
        }
      }
      &_add {
        @include icon(72px);
        margin: 0 60px;
        position: relative;
        @include invert_button("scale", $main_orange);
        color: $main_orange;
        &::after {
          @include pseudo(14px, 100%);
          content: "new";
          left: 0;
          @include fz(14);
          bottom: 12px;
        }
        &.active {
          background-color: $main_orange;
          i {
            color: #fff;
          }
        }
      }
      &_latest {
        text-align: center;
      }
      &.update {
        display: flex;
        justify-content: center;
        .item {
          &_btn_update {
            display: block;
          }
        }
      }
    }
    @include sp {
      padding: 20px 0;
      position: relative;
      .item {
        margin: 0;
        padding: 0 20px;
        border-right: none;
        &_div {
          width: auto;
        }
        &_title {
          display: none;
        }
        &_graph {
          @include icon(80px);
          margin-bottom: 10px;
          .graph {
            &_percentage {
              @include fz(12);
              span {
                @include fz(18);
              }
            }
            &_detail {
              display: none;
            }
            &_btn_add,
            &_btn_cheer {
              display: none;
            }
          }
        }
        &_latest {
          @include fz(14);
          text-align: center;
        }
        &_add {
          margin: 0 20px;
          @include icon(60px);
          min-width: 60px;
          &::after {
            bottom: 8px;
          }
        }
      }
    }
  }
  &_update {
    .update {
      &_btn {
        &_wrapper {
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        &_add,
        &_delete {
          padding: 4px 14px;
          @include fz(16);
          border-radius: 8px;
          color: $text_black;
        }
        &_add {
          border: 2px solid $main_orange;
          color: #fff;
          background-color: $main_orange;
          font-weight: 500;
          position: relative;
          input {
            /* 透明度0 */
            filter: alpha(opacity=0);
            -moz-opacity: 0;
            opacity: 0;
            /* ブラウザのデフォルトのスタイルを削除 */
            -webkit-appearance: none;
            appearance: none;
            /* レイアウトから無視 */
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
          }
        }
        &_delete {
          border: 2px solid $text_gray;
          color: $text_gray;
        }
        &_update {
          margin: 20px auto 0;
          padding: 4px 14px;
          @include fz(16);
          border-radius: 8px;
          background-color: $main_orange;
          border: 2px solid $main_orange;
          color: #fff;
        }
      }
      &_content {
        &_wrapper {
          height: 100%;
        }
        &_images {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-bottom: 20px;
          li {
            &:first-child {
              min-width: 72px;
              @include icon(72px);
              border-radius: 4px;
            }
            min-width: 56px;
            @include icon(56px);
            border-radius: 4px;
            background-color: $bg_accent;
            margin: 0 4px;
            position: relative;
            overflow: hidden;
            img {
              border-radius: 4px;
              width: 100%;
              height: 100%;
            }
          }
        }
        &_caption {
          text-align: left;
          p {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: nowrap;
          }
          #caption_length {
            @include fz(14);
            color: #393939;
          }
          textarea {
            background-color: #fff;
            min-height: 100px;
            width: 100%;
            @include fz(16);
            resize: vertical;
            border-radius: 4px;
            border: 1px solid $text_gray;
            padding: 4px;
          }
        }
      }
    }
    &.pc {
      margin-left: 60px;
    }
    &.sp {
      margin-top: 60px;
    }
  }
  @include sp {
    &_current {
      margin-top: 60px;
      align-items: center;
      @include flex_c();
      .item {
        width: 240px;
        text-align: center;
        &_title {
          @include text_overflow(2);
          @include fz(18);
          margin: 0 auto;
        }
        &_graph {
          @include challenge_graph(240px, 30, 18);
        }
        &_add {
          height: 72px;
          width: 72px;
          border-radius: 50%;
          min-width: 72px;
          background-color: #fff;
          box-shadow: 1px 1px 6px #0000003c;
          margin: 0 60px 60px;
        }
      }
      &.update {
        display: flex;
        flex-direction: column;
        .item {
          &_latest {
            display: none;
          }
        }
      }
    }
  }
}
</style>